import { Route } from '@angular/router';
import { NewJobComponent } from './newJob.component';

export const NewJobRoutes: Route[] = [
  {
    path: 'newJob',
    component: NewJobComponent
  }
];
